module.exports = "/_next/static/images/logo-20ae695226c00f4f8c9e0a60cdcef5cd.png";